import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpClientEngineConfigClass;
function HttpClientEngineConfig() {
  if (HttpClientEngineConfigClass === VOID) {
    class $ {
      constructor() {
        this.j5n_1 = 4;
        this.k5n_1 = null;
        this.l5n_1 = false;
        this.m5n_1 = null;
      }
    }
    initMetadataForClass($, 'HttpClientEngineConfig', HttpClientEngineConfig);
    HttpClientEngineConfigClass = $;
  }
  return HttpClientEngineConfigClass;
}
//region block: exports
export {
  HttpClientEngineConfig as HttpClientEngineConfig53hvl3zmhf7d,
};
//endregion

//# sourceMappingURL=HttpClientEngineConfig.mjs.map
